import {
  SET_PLACE_ID,
  SET_PLACE_ID_MARKER,
  GET_MARKER_POSITION,
  GET_OPEN_RESTAURANT_STATUS,
  SET_RESTAURANT_DETAILS,
  SET_RESTAURANT_SUBSCRIPTION_DETAILS,
  GET_VENDOR_MENU_CATEGORY,
  GET_VENDOR_MENU_CATEGORY_ITEMS,
  SET_ACTIVE_ITEM_ID_MENU_SETUP,
  SET_ACTIVE_ITEM_ID_MENU_SETUP_DATA,
  GET_VENDOR_ADDED_TEMPLATES,
  GET_VENDOR_ADDED_TEMPLATES_ALL,
  SET_ACTIVE_CATEGORY_DATA_MENU_SETUP,
  GET_VENDOR_ALL_MENU_ITEMS,
  GET_LOCAL_CATALOG_DATA,
  ACTIVE_CATALOG_NAME,
  ACTIVE_CATALOG_ID,
  SELECTED_ITEMS_ID,
  SELECTED_CATALOG_ITEMS,
  CATALOG_SELECTED_CATEGORIES_ITEMS,
  LOG_OUT,
  GET_LOCAL_ITEMS_DATA,
  UPDATE_SUBSCRIPTION_TYPE,
  SET_CURBSIDE_LOCATION,
  SET_CURBSIDE_LOCATION_ARR,
  SET_FASTFOOD_CURBSIDE_LOCATION_ARR,
  SET_MULTISERVICE_CURBSIDE_LOCATION_ARR,
  SET_PRODUCT_CLASSIFCATION,
  SET_PRODUCT_ACTIVE_CATID,
  REORDER_VENDOR_MENU_CATEGORY,
  REORDER_VENDOR_MENU_ITEM,
  REORDER_VENDOR_MENU_ITEM_STATUS,
  GET_MENU_SETUP_CATEGORY_ALL,
  GET_CUSTOM_MENU_LIST,
  BUSINESS_DETAILS_STEP,
  GET_FILTER_TABLE_DATA,
  ACTIVE_MENU,
} from '../../types';

const initialState = {
  place_id: {},
  placeIdMarker: {},
  markerPosition: [],
  restaurant_Open_Status: {},
  restaurantDetails: {},
  onboard_subscription_details: {},
  menuCategory: [],
  activeCategoryData: [],
  menuCategoryItems: [],
  activeItemId: '',
  vendor_templates: [],
  all_menu_items: [],
  all_local_catalog: [],
  all_local_catalog_items: [],
  activeCatalogName: '',
  activeCatalogId: '',
  selectedCatalogId: [],
  selectedCatalogItems: [],
  catalogSelectedCategoriesItems: {},
  subscriptionType: {
    casualDiningManagement: true,
    fastFoodOthersManagement: false,
    hospitalityAndHotelsManagement: false,
    multiSelectServices: false,
  },
  curbSidePickupDetails: {
    lat: '',
    lng: '',
    placeId: '',
    address: '',
  },
  curbSidePickupDetailsArr: [],
  fastFoodPickupDetailsArr: [],
  multiServicePickupDetailsArr: [],
  set_product_classification: '',
  reorder_menu_category_item: [],
  reorder_menu_item_data: [],
  reorder_menu_item_data_status: {
    status: false,
  },
  set_product_active_catId: '',
  get_menu_setup_category_all: [],
  businessDetailsStep: 1,
  get_filter_table_data: [],
  get_custom_menu_list: [],
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_SUBSCRIPTION_TYPE:
      return {
        ...state,
        subscriptionType: action.payload,
      };
    case SET_CURBSIDE_LOCATION:
      return {
        ...state,
        curbSidePickupDetails: action.payload,
      };
    case SET_CURBSIDE_LOCATION_ARR:
      return {
        ...state,
        curbSidePickupDetailsArr: action.payload,
      };
    case SET_FASTFOOD_CURBSIDE_LOCATION_ARR:
      return {
        ...state,
        fastFoodPickupDetailsArr: action.payload,
      };
    case SET_MULTISERVICE_CURBSIDE_LOCATION_ARR:
      return {
        ...state,
        multiServicePickupDetailsArr: action.payload,
      };
    case SET_PLACE_ID:
      return {
        ...state,
        place_id: action.payload,
      };
    case SET_PLACE_ID_MARKER:
      return {
        ...state,
        placeIdMarker: action.payload,
      };
    case GET_MARKER_POSITION:
      return {
        ...state,
        markerPosition: action.payload,
      };
    case GET_OPEN_RESTAURANT_STATUS:
      return {
        ...state,
        restaurant_Open_Status: action.payload,
      };
    case SET_RESTAURANT_DETAILS:
      return {
        ...state,
        restaurantDetails: action.payload,
      };
    case SET_RESTAURANT_SUBSCRIPTION_DETAILS:
      return {
        ...state,
        onboard_subscription_details: action.payload,
      };
    case GET_VENDOR_MENU_CATEGORY:
      return {
        ...state,
        menuCategory: action.payload,
      };
    case GET_VENDOR_MENU_CATEGORY_ITEMS:
      return {
        ...state,
        menuCategoryItems: action.payload,
      };
    case SET_PRODUCT_CLASSIFCATION:
      return {
        ...state,
        set_product_classification: action.payload,
      };
    case SET_PRODUCT_ACTIVE_CATID:
      return {
        ...state,
        set_product_active_catId: action.payload,
      };
    case SET_ACTIVE_ITEM_ID_MENU_SETUP:
      return {
        ...state,
        activeItemId: action.payload,
      };
    case SET_ACTIVE_ITEM_ID_MENU_SETUP_DATA:
      return {
        ...state,
        activeItemIdata: action.payload,
      };
    case GET_VENDOR_ADDED_TEMPLATES:
      return {
        ...state,
        vendor_templates: action.payload,
      };
    case GET_VENDOR_ADDED_TEMPLATES_ALL:
      return {
        ...state,
        all_vendor_templates: action.payload,
      };

    case SET_ACTIVE_CATEGORY_DATA_MENU_SETUP:
      return {
        ...state,
        activeCategoryData: action.payload,
      };

    case GET_VENDOR_ALL_MENU_ITEMS:
      let allData = action.payload.filter((item) => item.currentState === 9);
      return {
        ...state,
        all_menu_items: allData,
        // action.payload,
      };

    case GET_LOCAL_CATALOG_DATA:
      return {
        ...state,
        all_local_catalog: action.payload,
      };
    case GET_LOCAL_ITEMS_DATA:
      return {
        ...state,
        all_local_catalog_items: action.payload,
      };
    case ACTIVE_CATALOG_NAME:
      return {
        ...state,
        activeCatalogName: action.payload,
      };
    case ACTIVE_CATALOG_ID:
      return {
        ...state,
        selectedCatalogId: action.payload,
      };
    case SELECTED_ITEMS_ID:
      return {
        ...state,
        selectedItemsId: action.payload,
      };
    case SELECTED_CATALOG_ITEMS:
      return {
        ...state,
        selectedCatalogItems: action.payload,
      };
    case CATALOG_SELECTED_CATEGORIES_ITEMS:
      return {
        ...state,
        catalogSelectedCategoriesItems: action.payload,
      };
    case REORDER_VENDOR_MENU_CATEGORY:
      return {
        ...state,
        reorder_menu_category_item: action.payload,
      };
    case REORDER_VENDOR_MENU_ITEM:
      return {
        ...state,
        reorder_menu_item_data: action.payload,
      };
    case REORDER_VENDOR_MENU_ITEM_STATUS:
      return {
        ...state,
        reorder_menu_item_data_status: action.payload,
      };
    case GET_MENU_SETUP_CATEGORY_ALL:
      return {
        ...state,
        get_menu_setup_category_all: action.payload,
      };
    case GET_CUSTOM_MENU_LIST:
      return {
        ...state,
        get_custom_menu_list: action.payload,
      };
    case ACTIVE_MENU:
      return {
        ...state,
        active_menu: action.payload,
      };
    case BUSINESS_DETAILS_STEP:
      return {
        ...state,
        businessDetailsStep: action.payload,
      };
    case GET_FILTER_TABLE_DATA:
      return {
        ...state,
        get_filter_table_data: action.payload,
      };

    case LOG_OUT: {
      return {
        ...state,
        place_id: {},
        placeIdMarker: {},
        markerPosition: [],
        restaurantDetails: {},
        onboard_subscription_details: {},
        menuCategory: [],
        activeCategoryData: [],
        menuCategoryItems: [],
        activeItemId: '',
        vendor_templates: [],
        subscriptionType: {},
        all_menu_items: [],
      };
    }
    default:
      return state;
  }
}
